import { create, type StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'

import { MessageModel } from '@/app/models/messageModel'
import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  /** Ostatni komunikat (toast). Null = nic jeszcze nie pokazano. */
  message: MessageModel | null
}

type Actions = {
  showMessage: (message: MessageModel) => void
}

/** Ten sam cast co w pozostałych store'ach - patrz `genericErrorStore`. */
type StoreMutators = [['zustand/devtools', never]]

const trackedCreator = zustandPlugin as unknown as <T>(
  creator: StateCreator<T, StoreMutators, []>,
  name?: string,
) => StateCreator<T, StoreMutators, []>

/**
 * Szyna komunikatów (toasty), wcześniej slice `messages`.
 *
 * Slice miał jednego czytelnika (`MessageListener`) i kilkudziesięciu pisarzy.
 * Connect stał tu z `pure: false`, bo `MessagePresenter` odróżnia komunikaty po
 * `timestamp`, a ten sam obiekt wysłany dwa razy nie zmieniał referencji stanu.
 * Dlatego `showMessage` zawsze ustawia świeży znacznik czasu i nową referencję.
 */
export const useMessageStore = create<State & Actions>()(
  devtools(
    trackedCreator(
      (set) => ({
        message: null,
        showMessage: (message) =>
          set(
            { message: { ...message, timestamp: new Date() } },
            false,
            'show',
          ),
      }),
      'messages',
    ),
    { name: 'EasyTacho', store: 'messages' },
  ),
)

/** Poza Reactem i w `mapDispatchToProps`, gdzie nie ma hooków. */
export const showMessage = (message: MessageModel) =>
  useMessageStore.getState().showMessage(message)
